import { FC } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { List, ListItemIcon } from '@material-ui/core';
import {
  Item,
  StyledListItem,
  StyledListItemText,
} from 'containers/AppContainer/SideBar/style';
import HomeIcon from 'components/SahamIcons/HomeIcon';
import { translate } from 'containers/services/translate';
import messages from 'containers/AppContainer/messages';
import { history } from 'store';
import { PAGES } from 'routes';

const selectedItem = (paths: string[]) => {
  return paths.some(path => path === history.location.pathname);
};

export interface ConsultationManagerMenuProps {
  intl: IntlShape;
  isManager?: boolean;
  pushToAndReset: Function;
  isMenuOpen: boolean;
}

const ConsultationManagerMenu: FC<ConsultationManagerMenuProps> = (
  props,
): JSX.Element => {
  const { pushToAndReset, isMenuOpen } = props;
  return (
    <List>
      <Item>
        <StyledListItem
          open={isMenuOpen}
          button
          selected={selectedItem([PAGES.CONSULTATION_MANAGER_HOME])}
          onClick={pushToAndReset(PAGES.CONSULTATION_MANAGER_HOME)}
        >
          <ListItemIcon>
            <HomeIcon isActivated />
          </ListItemIcon>
          {isMenuOpen && (
            <StyledListItemText open={isMenuOpen}>
              <span className="menuItemText">
                {translate(messages.sideBarHomeTitle, props)}
              </span>
            </StyledListItemText>
          )}
        </StyledListItem>
      </Item>
    </List>
  );
};

export default injectIntl(ConsultationManagerMenu);
